/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RestrictionNotSetSessionLockdownParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('not-set')],
]);
export class RestrictionNotSetSessionLockdown extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RestrictionNotSetSessionLockdownParser.decode(input).map(res => new RestrictionNotSetSessionLockdown(res));
    }
    static unsafeDecode(input) {
        return RestrictionNotSetSessionLockdown.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RestrictionNotSetSessionLockdownParser.encode(data);
    }
    static schema() {
        return RestrictionNotSetSessionLockdownParser.schema();
    }
}
